<template>
    <div class="search-button">
        <div v-if="showSearchDisplay == true" class="my-4">
            <div class='table-back-ground table-wrap position-relative'>
                <div class="sectionTitle">プラン条件検索</div>
                <table class="condition-search-body planTableBody">
                    <tr class="tableRow">
                        <td class="sp_not">
                            <div class="icon_label">
                                <div class="icon_reserve_play_date condition-search-icon"></div>
                                <div class="icon_reserve_text">プレー日</div>
                            </div>
                        </td>
                        <td>
                            <span class="sp_label">プレー日</span>
                            <div class="play_date align-items-center">
                                <Datepicker
                                    typeable
                                    input-class="form-control"
                                    :language="ja"
                                    v-model="selectDate"
                                    @blur="checkInput"
                                    @input="checkInput"
                                    :format="DatePickerFormat"
                                ></Datepicker>
                                <div class="px-2">から</div>
                                <select v-model="selectDays" class="form-control select-box">

                                    <option v-for="select in selectdays_items" v-bind:value="select.code" v-bind:key="select.code">
                                        {{ select.code_name }}
                                    </option>
                                </select>
                                <div class="px-2">日分</div>
                                <select v-model="selectCells" class="form-control">
                                    <option v-for="select in cellsSelect" v-bind:value="select.code" v-bind:key="select.code">
                                        {{ select.code_name }}
                                    </option>
                                </select>
                                <div class="px-2">枠以上</div>
                            </div>
                            <div class="sp_play_date">
                                <input type="date" class="form-control sp-date" v-model="selectDate" @blur="checkInput" @input="checkInput">
                                <div class="px-1 sp-date">から</div>
                                <select v-model="selectDays" class="form-control pt-1 sp-select">
                                    <option v-for="select in selectdays_items" v-bind:value="select.code" v-bind:key="select.code">
                                        {{ select.code_name }}
                                    </option>
                                </select>
                                <div class="px-1 sp-date">日分</div>
                            </div>
                            <div v-if="dateError" class="text-danger">
                                {{ dateErrorMessage }}
                            </div>
                        </td>
                    </tr>
                    <tr class="tableRow">
                        <td class="sp_not">
                            <div class="icon_label">
                                <div class="icon_reserve_fee condition-search-icon"></div>
                                <div class="icon_reserve_text">料金(総額)</div>
                            </div>
                        </td>
                        <td>
                            <span class="sp_label">料金(総額)</span>
                            <div class="sp_input sp_input__flex">
                                <div>
                                    <select v-model="minprice" class="form-control select-box" @change="checkInput">
                                        <option v-for="select in priceSelect_items" v-bind:value="select.code" v-bind:key="select.code">
                                            {{ select.code_name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="d-flex justify-content-center align-items-center px-2">円&nbsp;～&nbsp;</div>
                                <div>
                                    <select v-model="maxprice" class="form-control select-box" @change="checkInput">
                                        <option v-for="select in priceSelect_items" v-bind:value="select.code" v-bind:key="select.code">
                                            {{ select.code_name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="d-flex justify-content-center align-items-center px-2">円</div>
                            </div>
                            <div v-if="priceError" class="text-danger">
                                {{ priceErrorMessage }}
                            </div>
                        </td>
                    </tr>
                    <tr class="tableRow">
                        <td style='width: 30%;' class="sp_not">
                            <div class="icon_label">
                                <div class="icon_reserve_start_time condition-search-icon"></div>
                                <div class="icon_reserve_text">スタート時間</div>
                            </div>
                        </td>
                        <td>
                            <span class="sp_label">スタート時間</span>
                            <div class="sp_input">
                                <span v-for="start_checkbox in starttime_items" :key="start_checkbox.code">
                                <label class="width-140 mr-2 mb-3">
                                    <input
                                        type="checkbox"
                                        v-model="selectTimeCode"
                                        :value="start_checkbox.code"
                                    >
                                    {{ start_checkbox.code_name }}
                                </label>
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr class="tableRow">
                        <td class="sp_not">
                            <div class="icon_label">
                                <div class="icon_reserve_play_style condition-search-icon"></div>
                                <div class="icon_reserve_text">プレースタイル</div>
                            </div>
                        </td>
                        <td>
                            <span class="sp_label">プレースタイル</span>
                            <div class="sp_input">
                                <span v-for="checkbox in playstyle_items" :key="checkbox.code">
                                    <label class="width-180 mr-2 mb-3">
                                        <input
                                            type="checkbox"
                                            v-model="selectStyleCode"
                                            :value="checkbox.code"
                                        >
                                            {{ checkbox.code_name }}
                                    </label>
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr class="tableRow">
                        <td class="sp_not">
                            <div class="icon_label">
                                <div class="icon_reserve_benefits condition-search-icon"></div>
                                <div class="icon_reserve_text">特典</div>
                            </div>
                        </td>
                        <td>
                            <span class="sp_label">特典</span>
                            <div class="sp_input">
                                <span v-for="checkbox in Benefits_items" :key="checkbox.id">
                                <label class="width-170 mr-2 mb-3">
                                    <input type="checkbox"
                                        v-model="selectBenefitsCode"
                                        :value="checkbox.benefit_cd"
                                    >
                                        {{ checkbox.benefit_name }}
                                </label>
                                </span>
                            </div>
                        </td>
                    </tr>
                </table>
                <div class="btnRow">
                    <button class='bluebackbutton separatebutton' @click="onClear">検索条件をクリア</button>
                    <button class='btn nextBtn separatebutton' v-if="showSearchBtn == false" @click="searchClick()">検索する</button>
                </div>
                <div class="text-center">
                    <button class='bluebackbutton closesearchbutton' v-if="closeBtn == true" @click="closeSearchDisplay">検索条件を閉じる</button>
                </div>
            </div>
        </div>
        <div v-if="showSearchBtn == true" class="container search-re-btn-container px-0 my-2">
            <button class='bluebackbutton search-re-btn' v-if="showSearchBtn == true" @click="switchSearchBtn()">検索条件を設定する</button>
        </div>
    </div>
</template>

<script>
import { GET_CODE_LIST_FOR_RESERVE } from '../../constants/reservepage_codelist';
import { GET_CODE_KEY_LIST } from '../../constants/codelist';
import { utilityMixin } from '../../mixins/utility';
import { ja } from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker';

export default {
    components: {
        Datepicker
    },
    mixins: [utilityMixin],
    props: ["reserveData"],
    data () {
        return {
            golfCourseCode: null,
            selectDate: null,
            // 選択された開始時間のチェックボックス配列
            selectTimeCode: [],
            // 選択されたプレイスタイルのチェックボックス配列
            selectStyleCode: [],
            // 選択された特典のチェックボックス配列
            selectBenefitsCode: [],
            // 日数選択の初期値
            selectDays: '01',
            selectCells: 1,
            // 最小金額の初期値
            minprice: 1,
            // 最大金額の初期値
            maxprice: 1,
            showSearchDisplay: true,
            showSearchBtn: false,
            closeBtn: false,
            checkbox: [],
            selectdays_items: null,
            starttime_items: null,
            playstyle_items: null,
            cells_items: null,
            priceSelect_items: null,
            Benefits_items: null,
            cellsSelect: null,
            loadingCount: 0,
            // 入力チェック用スイッチ
            dateError: false,
            dateErrorMessage: '',
            priceError: '',
            priceErrorMessage: '',
            // vuejs-datetimepickerの設定
            ja:ja,
            DatePickerFormat: 'yyyy-MM-dd',
            isMobile: false
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期処理
         * ---------------------------------------------- */
        initialize: async function () {
            // 親からゴルフコードを取得する
            this.golfCourseCode = this.reserveData.golfCode;
            this.selectDate = this.getDateStr(null);
            this.showSearchDisplay = false;
            this.showSearchBtn = false;

            // 検索条件取得
            await this.getConditionData();

            // 前画面からの遷移の場合
            // ゴルフ場サイトから遷移した場合
            // 前画面から戻って来た場合
            if (sessionStorage.getItem('Reserve.prevUrl') ) {
                this.getReserveData();
                this.showSearchBtn = true;
            } else if (
                this.$route.query.gc ||
                sessionStorage.getItem('Reserve.reserveNo') ||
                localStorage.getItem("Reserve.returnBackUrl")
            ) {
                this.onClear();
                this.selectDays = this.selectdays_items.slice(-1)[0].code;
                this.searchClick();

                if (localStorage.getItem("Reserve.returnBackUrl")) {
                    localStorage.removeItem("Reserve.returnBackUrl");
                }
            }
        },
        /** ----------------------------------------------
         * 予約変更
         * ---------------------------------------------- */
        chageReserve () {
            this.selectDate = this.reserveData.searchStartDate;
            this.selectDays = this.reserveData.searchSelectDays;
            this.selectCells = this.reserveData.searchSelectCells;
            // this.selectStyleCode = this.reserveRec.searchStyleList;
            this.searchClick();
            this.showSearchDisplay = true;
            this.showSearchBtn = false;
        },

        /** ----------------------------------------------
         * 検索条件設定
         *   画面に表示する各検索条件を設定する
         * @param {array} codeKeyRecList 各コードのリスト
         * ---------------------------------------------- */
        setConditionData: function (codeKeyRecList) {
            for (var i = 0 ; i < codeKeyRecList.length ; i++) {
                if (codeKeyRecList[i].codeKey == "day_selectbox") {
                    this.selectdays_items = codeKeyRecList[i].codeRec;
                } else if (codeKeyRecList[i].codeKey == "starttime_checkbox") {
                    this.starttime_items = codeKeyRecList[i].codeRec;
                } else if (codeKeyRecList[i].codeKey == "playstyle_checkbox") {
                    this.playstyle_items = codeKeyRecList[i].codeRec;
                } else if (codeKeyRecList[i].codeKey == "cells_selectbox") {
                    this.cellsSelect = codeKeyRecList[i].codeRec;
                } else if (codeKeyRecList[i].codeKey == "price_selectbox") {
                    this.priceSelect_items = codeKeyRecList[i].codeRec;
                }
            }
        },

        /** ----------------------------------------------
         * 検索条件取得
         *   画面に表示する各検索条件をコードマスタより取得する
         * ---------------------------------------------- */
        getConditionData: async function () {
            this.loadingOn();
            var me = this;
            await this.$apollo.query({
                query: GET_CODE_LIST_FOR_RESERVE,
                variables: {
                    golf_group_code: process.env.MIX_GROUP_CODE,
                    golf_code: this.golfCourseCode
                }
            }).then(res => {
                me.setConditionData(res.data.GetCodeListForReserve.CodeKeyRecList);
                me.Benefits_items = res.data.GetCodeListForReserve.SpecialList;
                for (var i = 0 ; i < this.Benefits_items.length ; i++) {
                    this.Benefits_items[i].id = i + 1;
                }
                this.$emit('set-golf-info', res.data.GetCodeListForReserve.golf_course_img_path)
                me.loadingOff();
            }).catch(error => {
                const message = error.message.split(':');
                // 親へ処理終了を伝える（異常）
                me.$emit('finished-proc', false);
            });
        },
        /** ----------------------------------------------
         * 検索条件をクリアボタン処理
         *   検索条件を初期化する
         * ---------------------------------------------- */
        onClear: function () {
            this.selectDate = this.getDateStr(null);
            this.selectDays = '01';
            this.selectCells = 1;
            this.minprice = 1;
            this.maxprice = 1;
            this.selectTimeCode = [];
            this.selectStyleCode = [];
            this.selectBenefitsCode = [];
            this.dateError = false;
            this.priceError = false;
            this.dateErrorMessage = "";
            this.priceErrorMessage = "";
        },
        /** ------------------------------------------------------------------------
         * 検索するボタン処理
         *   ボタンの状態によりプラン条件検索画面の表示及びプラン選択画面の表示を行う
         * ------------------------------------------------------------------------- */
        searchClick: function () {
            // 入力チェック
            if (!this.checkInput()) {
                return;
            }

            // 検索ボタンが表示されている場合
            if (this.showSearchBtn == true) {
                this.showSearchBtn = false;
                this.showSearchDisplay = true;
            } else {
                this.setReserveData();

                this.showSearchBtn = true;
                this.showSearchDisplay = false;
                this.$emit('searc-click');
            }
            // 初回検索ボタン押下後、閉じるボタン表示（初期画面非表示）
            this.closeBtn = true;
        },
        /**-------------------------------------------------------------------------
         * 閉じるボタン処理
         *  閉じるボタン押下時、プラン条件検索画面を非表示にし、
         *  「検索条件を再設定する」ボタンを表示させる
         * ------------------------------------------------------------------------- */
        closeSearchDisplay: function () {
            this.showSearchDisplay = false;
            this.showSearchBtn = true;
        },
        /**-------------------------------------------------------------------------
         * 検索ボタン条件表示処理
         *  閉じるボタン押下時、プラン条件検索画面を非表示にし、
         *  「検索条件を再設定する」ボタンを表示させる
         * ------------------------------------------------------------------------- */
        switchSearchBtn: function () {
            this.showSearchDisplay = true;
            this.showSearchBtn = false;
        },
        /** ------------------------------------------------------------------------
         * 入力チェック処理
         *
         * ------------------------------------------------------------------------- */
        checkInput: function () {
            this.dateError = false;
            this.priceError = false;
            this.dateErrorMessage = "";
            this.priceErrorMessage = "";
            var nowDate = this.getDateStr(null);
            var inputDate = this.getDateStr(new Date(this.selectDate));
            if (nowDate > inputDate) {
                this.dateError = true;
                this.dateErrorMessage = "プレー日は現在日以前を指定できません。";
            }
            if (inputDate == 'NaN-aN-aN') {
                this.dateError = true;
                this.dateErrorMessage = "プレー日を指定してください。";
            }
            if (Number(this.minprice) !== 1 && Number(this.maxprice) !== 1) {
                if (this.minprice > this.maxprice) {
                    this.priceError = true;
                    this.priceErrorMessage = "料金の範囲指定が不正です。";
                }
            }
            if (this.dateError === false && this.priceError === false) {
                return true;
            }
            return false;
        },
        /** ------------------------------------------------------------------------
         * 検索条件設定処理
         * ------------------------------------------------------------------------- */
        setReserveData: function () {
            this.reserveData.searchStartDate = this.selectDate;
            this.reserveData.searchSelectDays = this.selectDays;
            this.reserveData.searchSelectCells = this.selectCells;
            this.reserveData.searchPriceMin = this.minprice;
            this.reserveData.searchPriceMax = this.maxprice;
            this.reserveData.searchStartTimeList = this.selectTimeCode;
            this.reserveData.searchStyleList = this.selectStyleCode;
            this.reserveData.searchBenefitsList = this.selectBenefitsCode;
        },
        /** ------------------------------------------------------------------------
         * 検索条件取得処理
         *
         * ------------------------------------------------------------------------- */
        getReserveData: function () {
            // this.reserveData.searchStartDate = '';
            // if (!this.reserveData.searchStartDate) {
            //     console.log('TEST');
            // } else {
            //     console.log(this.reserveData.searchStartDate);
            //     this.selectDate = this.reserveData.searchStartDate;
            // }
            this.selectDate = this.reserveData.searchStartDate;
            this.selectDays = this.reserveData.searchSelectDays;
            this.selectCells = this.reserveData.searchSelectCells;
            if (this.reserveData.searchPriceMin == 0) {
                this.minprice = 1;
            } else {
                this.minprice = this.reserveData.searchPriceMin;
            }
            if (this.reserveData.searchPriceMax == 0) {
                this.maxprice = 1;
            } else {
                this.maxprice = this.reserveData.searchPriceMax;
            }
            this.selectTimeCode = this.reserveData.searchStartTimeList;
            this.selectStyleCode = this.reserveData.searchStyleList;
            this.selectBenefitsCode = this.reserveData.searchBenefitsList;

        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function () {
            this.loadingCount++;
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function () {
            this.loadingCount--;
            if (this.loadingCount <= 0) {
                // 親へ処理終了を伝える（正常）
                this.$emit('finished-proc', true);
            }
        },

    }
}

</script>

<style scoped>
tr{
  border: solid 1px #e8e8e8;
}
td{
  border: solid 1px #e8e8e8;
}
select{
    height: 33px;
}
.vdp-datepicker ::v-deep input {
    width: 110px;
}
.select-box{
    padding-top: 4px;
}
.play_date {
    display: flex;
}
.sp_play_date {
    display: none;
}
@media screen and (max-width: 896px) {
    .play_date {
        display: none;
    }
    .sp_play_date {
        width: 100%;
        display: flex;
        align-items: center;
    }
    .sp-date {
        width: fit-content;
    }
    .sp-select {
        min-width: 70px;
        max-width: 70px;
        height: calc(1.5em + 0.75rem + 2px);
    }
    .search-button {
        padding: 0 15px;
    }
}
</style>
